<template>
    <div :class="$style['box']">
      <span :class="$style['box-title']">
        Exchange
      </span>
      <span :class="$style['box-subtitle']">
        Percentage in each portfolio
      </span>
    </div>
    <div v-if="exchanges.length > 1" :class="$style['box-l']">
      <div v-for="exchange in exchanges" :class="$style['exchange-box']" v-bind:key="exchange.id">
        <div :class="$style['exchange-box-init']">
          <img :src="require('@images/icons/'+getIcon(exchange.name_exchange))" alt="">
          <span :class="$style['exchange-box-percent']">
            {{  Math.trunc(exchange.percent_total * 100) / 100 }}%
          </span>
        </div>
        <div :class="$style['exchange-box-info']">
          <span :class="$style['exchange-box-info-value']">
            {{ formatToUSD(exchange.current_value) }}
          </span>
          <span :class="$style['exchange-box-info-name']">
            {{ exchange.name_exchange }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="exchanges.length < 1" style="font-size: 18px;font-weight: 800;text-align: center;margin-top: 25px;">
      No Data Found
    </div>
</template>

<script>
import { formatToUSD } from '@/helpers/currencyFormatter';


export default {
  name: 'ExchangesList',

  data() {
    return {
    }
  },

  props: {
    exchanges: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    formatToUSD,
    getIcon(exchange) {
      let icon = 'default.svg'

      if (exchange == 'kraken') {
        icon = 'kraken.svg'
      } else if (exchange == 'bybit') {
        icon = 'bybit.svg'
      } else if (exchange == 'binance') {
        icon = 'binance.svg'
      } else if (exchange == 'hyperliquid') {
        icon = 'hyperliquid.svg'
      }

      return icon
    }
  }
}
</script>

<!-- TODO quando for mobile deixar na msm linha -->

<style lang="scss" module>

  .box-l {
    margin-top: 10px;
    gap:25px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));

    @include respond-to(null, 'sm') {
      gap: 10px !important;
      grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    }
  }

  .box {
    display: flex;
    gap: 25px;
    align-items: center;

    @include respond-to(null, 'xs') {
      gap: 5px !important;
      flex-wrap: wrap;
    }

    &-title {
      color: #D9D9D9;
      font-size: 26px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px;

      @include respond-to(null, 'xs') {
        font-size: 22px !important;
      }
    }

    &-subtitle {
      color: #A6A6A6;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }
  }

  .exchange-box {
    border-radius: 16px;
    background: rgba(45, 45, 45, 0.35);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    gap: 30px;
    padding: 15px 20px;
    justify-content: space-between;

    @include respond-to(null, 'xs') {
      gap: unset !important;
      padding: 10px !important;
    }

    &-percent {
      color: #F3BA2F;
      font-size: 30px;
      font-style: normal;
      font-weight: 600;
      line-height: 58px;

      @include respond-to(null, 'xs') {
        line-height: normal;
        font-size: 20px;
        padding-top: 32px;
      }
    }

    &-init {
      display: flex;
      align-items: center;
      gap: 10px;

      @include respond-to(null, 'xs') {
        gap: 3px;
        img {
          width: 46px;
        }
      }
    }

    &-info {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      &-value {
        color: #F3BA2F;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 36px;
        position: relative;
        bottom: -15px;

        @include respond-to(null, 'xs') {
          bottom: 0;
          line-height: normal;
        }
      }

      &-name {
        color: rgba(243, 186, 47, 0.10);
        font-size: 26px;
        font-style: normal;
        font-weight: 600;
        line-height: 42px;
        position: relative;
        bottom: -15px;

        @include respond-to(null, 'xs') {
          bottom: 0;
          line-height: normal;
          font-size: 18px;
        }
      }
    }
  }

</style>
